// extracted by mini-css-extract-plugin
export default {"form":"_3a236969","loginFormWrapper":"_7cf01239"};